<template>
  <div>
    <va-card class="overflow-auto">
      <vue-element-loading :active="visible" :is-full-screen="true" />
      <div class="row">
        <div class="flex md6 sm6 xs12">
          <h4 style="font-size: 24px !important">{{ heading }}</h4>
        </div>
      </div>
      <b-row class="pb-4">
        <b-col cols="12">
          <b-input-group prepend="Search key" class="mt-3">
            <b-form-input
              v-model="keyword"
              placeholder="Please Enter UserId or Name"
            ></b-form-input>
            <b-input-group-append>
              <b-button variant="info">
                <i class="fa fa-search"></i>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <h5>*Select the option to filter the results</h5>
      <div class="row">
        <div class="flex md4 sm6 xs12">
          <div class="form-group">
            <label
              for="exampleInputEmail1"
              style="text-align: left !important"
            ></label>
            <select
              class="filter pt-2 pb-2"
              style="width: 100% !important"
              v-model="uname"
            >
              <option class="text-center" value selected disabled hidden>
                Select User Type
              </option>
              <option v-bind:value="null">All</option>
              <option
                v-for="ut in usertype"
                :key="ut._id"
                v-bind:value="ut._id"
              >
                {{ ut.uname }}
              </option>
            </select>
          </div>
        </div>
        <div v-if="excelData" class="flex md8 xs12 text-right">
          <vue-excel-xlsx
            v-if="excelData.length > 0"
            :data="excelData"
            :columns="columns"
            :filename="'userList'"
            :sheetname="'sheetname'"
            class="btn btn-success px-2"
            style="padding-top: 6px; padding-bottom: 6px"
            >Download in Excel</vue-excel-xlsx
          >
        </div>
      </div>
      <div class="flex md12 sm6 xs12 overflow-auto">
        <div class="overflow-auto" style="overflow: auto">
          <b-table
            hover
            v-if="data.length"
            id="my-table"
            :fields="fields"
            :items="data"
            small
            borderless
            head-variant="dark"
            table-variant="light"
          >
            <template v-slot:cell(sno)="data">
              <span v-if="currentPage > 1">{{
                (currentPage - 1) * perPage + data.item.sno
              }}</span>
              <span v-else>{{ data.item.sno }}</span>
            </template>
            <template v-slot:cell(create_date)="data">
              <p v-if="data.item.create_date">
                {{ formatDate(data.item.create_date) }}
              </p>
            </template>
            <template v-slot:cell(status)="data">
              <span
                class="text-capitalize"
                :style="{ color: chooseColor(data.item.status) }"
                >{{ data.item.status }}</span
              >
            </template>
            <template v-slot:cell(_id)="data">
              <router-link :to="'/userview/' + data.item._id">
                <b-button class="pr-4 pl-4" variant="success">View</b-button>
              </router-link>
            </template>
            <template v-slot:cell(userDelete)="data">
              <b-button
                class="pr-4 pl-4"
                variant="danger"
                @click="deleteUser(data.item._id)"
                >Remove</b-button
              >
            </template>
          </b-table>
          <p v-else>No Data Found</p>
          <br />
          <b-pagination
            align="center"
            v-model="currentPage"
            :total-rows="totalData"
            :per-page="perPage"
            prev-text="Prev"
            next-text="Next"
            @change="nextPage"
            aria-controls="my-table"
          ></b-pagination>
          <br />
        </div>
      </div>
    </va-card>
  </div>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'
export default {
  components: {
    VueElementLoading,
  },
  props: ['type'],
  data () {
    return {
      uname: '',
      usertype: [],
      visible: false,
      perPage: 40,
      currentPage: 1,
      dat: [],
      keyword: null,

      fields: [
        {
          key: 'sno',
          label: 'S.No',
          tdClass: 'text-center',
          thClass: 'text-center',
        },
        {
          label: 'ID',
          key: 'userID',
          sortable: false,
        },
        {
          label: 'Name',
          key: 'fullName',
          sortable: false,
        },
        {
          label: 'User Type',
          key: 'usertype.uname',
          sortable: false,
        },
        {
          key: 'email',
          label: 'Email',
          sortable: false,
        },
        {
          key: 'phone',
          label: 'Phone',
          sortable: false,
        },
        {
          key: 'create_date',
          label: 'Reported Date',
          sortable: false,
          tdClass: 'text-center w-50',
          thClass: 'text-center',
        },

        {
          label: '',
          key: '_id',
          sortable: false,
          thClass: ' pdngtblcol1 , cnt',
          tdClass: 'cnt',
        },
        {
          label: '',
          key: 'userDelete',
          sortable: false,
          thClass: ' pdngtblcol1 , cnt',
          tdClass: 'cnt',
        },
      ],
      columns: [
        {
          label: 'Sl. NO.',
          field: 'sno',
        },
        {
          label: 'User Id',
          field: 'userID',
        },
        {
          label: 'Name',
          field: 'fullName',
        },
        {
          label: 'Email',
          field: 'email',
        },
        {
          label: 'Phone',
          field: 'phone',
        },
        {
          label: 'User Type',
          field: 'userType',
        },
        {
          label: 'State',
          field: 'state',
        },
      ],
      data: [],
      excelData: [],
      totalData: '',
    }
  },

  mounted: function () {
    this.getList()
    this.getExcelData()
    this.userview()
  },
  computed: {
    rows () {
      return this.data.length
    },
    heading () {
      var value
      if (this.type == 'all') {
        {
          value = 'TOTAL USERS'
          this.fields.splice(this.data.length - 2, 0, {
            key: 'status',
            label: 'Status',
            tdClass: 'text-left',
            thClass: 'text-left',
          })
        }
      } else if (this.type == 'pending') {
        value = 'PENDING USERS'
      } else if (this.type == 'active') {
        value = 'ACTIVE USERS'
      } else if (this.type == 'reject') {
        value = 'REJECTED USERS'
      }
      console.log('val', value)
      return value
    },
  },
  watch: {
    uname: function () {
      this.getList()
    },
    type () {
      this.getList()
      this.uname = null
    },
    currentPage () {
      this.getList()
    },
    keyword: function () {
      this.getList()
    },
  },
  methods: {
    formatDate (date) {
      return moment(date).format('DD-MM-YYYY')
    },
    chooseColor (status) {
      if (status == 'pending') return 'blue'
      if (status == 'active') return 'green'
      if (status == 'reject') return 'red'
    },
    nextPage (ev) {
      this.currentPage = ev
      this.getList()
    },
    reset () {
      window.location.reload()
    },
    deleteUser (val) {
      if (confirm('Are you sure?')) {
        this.visible = true
        axios({
          method: 'POST',

          headers: {
            token: localStorage.getItem('token'),
          },
          url: '/admin/user/delete/' + val,
        })
          .then((response) => {
            this.visible = false
            if (response.data.status) {
              this.msg = response.data.msg
              this.$dlg.alert(this.msg, () => {}, { messageType: 'success' })
              this.getList()
            } else {
              this.msg = response.data.msg
              this.$dlg.alert(this.msg, () => {}, { messageType: 'error' })
            }
          })
          .catch((err) => {
            this.visible = false
            this.errors.push(err)
            this.$dlg.alert(
              this.msg,
              () => {
                // this.$router.push("/Dashboard");
              },
              { messageType: 'error' }
            )
          })
      } else {
        this.visible = false
        this.$router.go(-1)
      }
    },
    userview () {
      // this.visible = true;
      axios({
        method: 'GET',
        url: '/usertype/list',
      })
        .then((response) => {
          this.usertype = response.data.data
          // this.visible = false;
        })

        .catch((err) => {
          // this.visible = false;
          console.log(err)
        })
    },
    getList () {
      var data1 = {}
      this.visible = true
      if (this.uname !== '') {
        data1['usertype'] = this.uname
      }
      if (this.type != 'nodata' || 'all') {
        data1['type'] = this.type
      }
      if (this.keyword) {
        data1['keyword'] = this.keyword
      }
      // this.currentPage=parseInt(this.currentPage,10)
      data1['page'] = this.currentPage
      data1['limit'] = this.perPage
      axios({
        method: 'POST',
        url: '/user/list',
        headers: {
          token: localStorage.getItem('token'),
        },
        data: data1,
      })
        .then((response) => {
          // console.log(response.data.data)
          if (response.data.status === true) {
            for (var i = 0; i < response.data.data.length; i++) {
              response.data.data[i].sno = i + 1
            }
            this.data = response.data.data
            this.totalData = response.data.totalLength
            this.visible = false
          } else if (response.data.status === false) {
            this.visible = false
          }
        })
        .catch((e) => {
          console.log(e)
          this.visible = false
          this.errors.push(e)
          this.msg = 'failed'
        })
    },
    getExcelData () {
      var data1 = {}
      this.visible = true
      if (this.uname !== '') {
        data1['usertype'] = this.uname
      }
      if (this.type != 'nodata' || 'all') {
        data1['type'] = this.type
      }
      if (this.keyword) {
        data1['keyword'] = this.keyword
      }
      axios({
        method: 'POST',
        url: '/user/list',
        headers: {
          token: localStorage.getItem('token'),
        },
        data: data1,
      })
        .then((response) => {
          // console.log(response.data.data)
          if (response.data.status === true) {
            for (var i = 0; i < response.data.data.length; i++) {
              response.data.data[i].sno = i + 1
              if (response.data.data[i].usertype) {
                console.log(response.data.data[i].usertype.uname)
                response.data.data[i].userType =
                  response.data.data[i].usertype.uname
              } else {
                response.data.data[i].userType = '-'
                console.log('-')
              }
            }
            this.excelData = response.data.data
            this.visible = false
          } else if (response.data.status === false) {
            this.visible = false
          }
        })
        .catch((e) => {
          console.log(e)
          this.visible = false
          this.errors.push(e)
          this.msg = 'failed'
        })
    },
  },
}
</script>

<style>
</style>
